import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

import { Region } from '@/types';

export const MarketingConsentCheckbox = ({
  marketingOptIn,
  onChange,
  country,
}: {
  marketingOptIn: boolean;
  onChange: (value: boolean) => void;
  country?: Region;
}) => {
  return (
    <Box
      sx={{
        cursor: 'pointer',
        display: 'flex',
        gap: 0.5,
        userSelect: 'none',
      }}
      onClick={() => {
        onChange(!marketingOptIn);
      }}>
      {marketingOptIn ? (
        <CheckBox
          sx={{
            color: 'secondary.main',
          }}
        />
      ) : (
        <CheckBoxOutlineBlank sx={{ color: 'secondary.main' }} />
      )}
      <Typography
        variant="caption1"
        sx={{ display: 'inline', color: 'text.light' }}>
        {country === 'USA'
          ? `Send me product updates, insights, and promotional emails from LumiQ. You can unsubscribe at any time.`
          : `I agree to receive marketing emails from LumiQ, including product updates, insights, and promotions. You can unsubscribe at any time.`}
      </Typography>
    </Box>
  );
};
